export default {"src":"/_next/static/media/external-arrows.c2bea3ab.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};